// isTesting matches the canonical shared/utils/env: NODE_ENV=test, an E2E_TEST build, or runtime
// under Playwright (window.Playwright is injected by packages/playwright's test-setup). The
// isPlaywright term lets the production bundle behave as "testing" under e2e with no test build.
export const isPlaywright = typeof window !== "undefined" && "Playwright" in window;
export const isTesting = Config.nodeEnv === "test" || Config.e2eTest || isPlaywright;
export const isDev = Config.nodeEnv === "development";
export const isProd = Config.nodeEnv === "production";

export { isTesting as isTest, isDev as isDevelopment, isProd as isProduction };

const env = {
  isTest: isTesting,
  isTesting,
  isPlaywright,
  isDev,
  isDevelopment: isDev,
  isProd,
  isProduction: isProd,
};

export default env;
